module.exports = __webpack_public_path__ + "media/images/equipments-img-02-b9d0366b4ed74b1659ec205af59ed131.png";